<template>
  <v-btn
    :text="text"
    class="button"
    :color="color"
    depressed
    :outlined="outlined"
    :min-width="width"
    :min-height="height"
    :disabled="disabled"
    :ripple="ripple"
    :fab="fab"
    :small="small"
    :icon="icon"
    @click="handleClick"
  >
    <slot />
  </v-btn>
</template>

<script>
export default {
  name: 'Button',
  props: {
    text: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: undefined,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: undefined,
    },
    height: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    ripple: {
      type: Boolean,
      default: false,
    },
    fab: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick(e) {
      e.preventDefault()
      this.$emit('click')
    },
  },
}
</script>

<style scoped>
.button {
  text-transform: none;
  font-size: 14px;
}
.button:active {
  font-weight: 700;
}
</style>
